import { Box, Skeleton } from '@mui/material';

interface BreakingMarketCardSkeletonProps {
  showDivider: boolean;
}

export const BreakingMarketCardSkeleton = ({ showDivider }: BreakingMarketCardSkeletonProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, sm: 2.25 },
        px: { xs: 1.5, sm: 2.75 },
        py: { xs: 1.75, sm: 2.25 },
        borderBottom: showDivider ? '1px solid' : 'none',
        borderColor: 'divider',
      }}
    >
      <Skeleton variant="text" width={18} height={20} />
      <Skeleton
        variant="rounded"
        width={42}
        height={42}
        sx={{ borderRadius: '11px', flexShrink: 0 }}
      />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="text" width="70%" height={22} />
        <Skeleton variant="text" width={70} height={16} sx={{ mt: 0.5 }} />
      </Box>

      <Box sx={{ width: 92, flexShrink: 0 }}>
        <Skeleton variant="text" width={60} height={26} sx={{ ml: 'auto' }} />
        <Skeleton variant="text" width={44} height={16} sx={{ ml: 'auto', mt: 0.5 }} />
      </Box>

      <Skeleton
        variant="rounded"
        width={100}
        height={36}
        sx={{ display: { xs: 'none', sm: 'block' }, flexShrink: 0 }}
      />

      <Skeleton variant="circular" width={20} height={20} />
    </Box>
  );
};

export default BreakingMarketCardSkeleton;
